import { Injectable } from '@angular/core';
import { urlServices } from './../../models/url.models';
import { HttpServiceService } from './../../../common-service/http-service.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class SecexcuService {

  constructor(public http: HttpServiceService, public url: urlServices, public ced: encryptionService, public serverURL: ServerURLService) { }
  // All Get Calls
  getAll(pageId: number, rows: number) {
    return this.http.get(this.url.getComplainintsofsecexc + 'userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).userId +
      '&page=' + pageId + '&rows=' + rows);
  }
  serchGetData(search: any, pageId: number, rows: number) {
    const obj = {
      searchWord : search,
      page : pageId,
      rows : rows,
      roleName : this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()  
    }
    return this.http.post(this.url.searchSEComplList,obj);
  }
  getCompliantDetails(complaintId: any) {
    const obj = {
      complaintId : complaintId
    }
    return this.http.post(this.url.getComplaint,obj);
    //return this.http.get(this.url.getComplaint + '?complaintId=' + id);
  }
  getSDCList() {
    return this.http.get(this.url.getSDClist);
  }
  sectionDashboard() {
    return this.http.get(this.url.seDashboardCount);
  }
  getAgendaNumbers(id: any) {
    return this.http.get(this.url.agendaList + '?sectionId=' + id);
  }
  getAgendaItemNumber() {
    return this.http.get(this.url.getAgendaItemNumber);
  }

  getAgendaItemNumberPtr() {
    return this.http.get(this.url.getAgendaItemNumberPtr);
  }

  getExistsAgenda(applicationId:any) {
    const applicationIdEncr = encodeURIComponent(this.ced.encryptAesToString(applicationId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getExistsAgenda+ '?applicationId=' + applicationIdEncr);
  }

  getExistsAgendaDetails(applicationId:any) {
    const applicationIdEncr = encodeURIComponent(this.ced.encryptAesToString(applicationId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getExistsAgendaDetails+ '?applicationId=' + applicationIdEncr);
  }

  getAgendaDetails(id: any) {
    return this.http.get(this.url.agendaDetails + '?complaintId=' + id);
  }

  // post
  agendaCreate(data: any) {
    return this.http.post(this.url.agendaCreation, data);
  }

  agendaPtrCreate(data: any) {
    return this.http.post(this.url.agendaPtrCreation, data);
  }

  forwardSDC(obj: any, filearray: any) {
    const formdata = new FormData();
    formdata.append('workflowStr', JSON.stringify(obj));
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    return this.http.post(this.url.forwardSDC, formdata);
  }

  forwardColleage(workflowStr: any, files: any) {
    const formdata = new FormData();
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      formdata.append('file', files[i]);
    }
    formdata.append('workflowStr', JSON.stringify(workflowStr));
    return this.http.post(this.url.forwardCollege, formdata);
  }

  // PUT Calls
  agendaFinalRespinse(data: any) {
    return this.http.update(this.url.finalResponse, data);
  }

  updateAgenda(data: any) {
    return this.http.update(this.url.updateAgenda, data);
  }

  // Delete calls
  deleteAgenda(id: number) {
    return this.http.delete(this.url.agendaDelete + '?complaintId=' + id);
  }

  updateGrievanceWorkflow(data: any) {
    return this.http.post(this.url.updateGrievanceWorkflow, data);
  }
  
  getComplainantViewPdf(complaintId: any) {
    const obj = {
      complaintId: this.ced.encryptAesToString(complaintId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.getComplainantViewPdf, obj);
  }

}
